import { render, staticRenderFns } from "./endorsement.vue?vue&type=template&id=5e659fd6&scoped=true&"
import script from "./endorsement.vue?vue&type=script&lang=js&"
export * from "./endorsement.vue?vue&type=script&lang=js&"
import style0 from "./endorsement.vue?vue&type=style&index=0&id=5e659fd6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e659fd6",
  null
  
)

export default component.exports